export const customerDataFromParamsUtils = (param: string | undefined) => {
  const idAndName = param ? param.split('__') : [];

  if (idAndName.length) {
    idAndName[1] = idAndName[1] ? idAndName[1]?.replace('_', ' ') : 'Customer';
  }

  return idAndName;
};
